import VueRouter from 'vue-router';
import Vue from 'vue'
import componentGroup from './component.js';
import Qs from "qs";
import store from './store.js'
import  {i18n}  from './language'

//console.log('i18n实例：', i18n) 

import {
	forEach
} from 'core-js/core/dict';
Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
	return originalPush.call(this, location).catch(err => err);
}

let status = false;

let Myrouters3 = [];
let UserMenus = [];

const Myrouters = [
	// {
	// 	path: '/',
	// 	title: '',
	// 	topTitle: '',
	// 	component: (resolve) => require(['./components/Escort'], resolve),
	// 	redirect: '/StationMonitoring/EquipmentMonitoring',
	// }, 
	{
		path: '/login',
		title: 'login',
		topTitle: '',
		name: 'login',
		meta: {
			menuId: -1
		},
		component: (resolve) => require(['./components/login/index.vue'], resolve),
		//redirect: '/tracking'
	},
	{
		path: '/test', //运营总览
		title: '场站总览',
		topName: '运营管理',
		meta: {
			menuId: -1
		},
		component: (resolve) => require(['./components/Archives/MerchantManagement/MerchantManagement.vue'],
			resolve),
	},
];

const RouterConfig = {
	routes: Myrouters
};
const router = new VueRouter(RouterConfig);

// 全局前置守卫
router.beforeEach((to, from, next) => {
	console.log("全局守卫to, from", to, from)
	// console.log(sessionStorage.first)
	// 判断有菜单并且不能少于一个功能
	if (to.path == from.path) {
		if (to.path == '/') next('/login')
		return;
	}
	if (to.path == '/login') {
		return next();
	}
	if (localStorage.AccessToken) { //判断是否登录
		if (localStorage.menuFlag == 'load' || localStorage.menuFlag == undefined || Myrouters3.length == 0 ||
			store.state.silderMethod.length == 0) {
			console.log("全局守卫1")
			routerGo(to, next)
		} else {
			console.log("全局守卫2")
			if (to.path == '/') {
				next('/login')
			} else {
				next()
			}
		}
	}
	next();
	
})

function routerGo(to, next) {
	const routerList = userRoute();
	console.log("routerGo", to)
	if (localStorage.menuFlag != "load") {
		next({
			path: to.path,
			query: to.query
		})
	} else {
		if (routerList.length <= 2) {
			next({
				path: routerList[1].path,
				query: to.query
			})
		} else if (routerList.length > 2) {
			next({
				path: routerList[2].path,
				query: to.query
			})
		}
		sessionStorage.setItem("first", 'no');
	}
}

function getUserMenus() {
	const _this = this
	return _this.$axios.post(webapi.base_api_url + "/Home/GetUserMenus", {}).then(res => {
		console.log("获得用户菜单")
		console.log(res)
		if (res.data.Code == 0) {
			localStorage.setItem("UserMenus", JSON.stringify(res.data.Data.List));
		} else {
			console.log("获得用户菜单错误")
		}
	})
}

const userRoute = function() {
	console.log("菜单筛选：")
	Myrouters3 = [];
	let menus = [];
	let topMenus = [];
	let Menus2 = JSON.parse(localStorage.getItem("UserMenus"));

	for (let variable in Menus2) {
		Menus2[variable].forEach(function(value2, index, array) {
			if (value2.title != "营收概况") {
				menus.push(value2)
			}
		})
	}
	
	menus.forEach(function(firstMenusIteam, index, array) {
		let first = [];
		let second = [];
		console.log(firstMenusIteam);
		var test =i18n.t('login')
		//var test =i18n.$t('login');
		//firstMenusIteam.title = i18n.t(firstMenusIteam.name);
		// 优先使用菜单专用翻译键（如 SplitRuleMenu），否则使用默认键
		const menuKey = firstMenusIteam.name + 'Menu';
		if (i18n.te(menuKey)) {
			firstMenusIteam.DisplayName = i18n.t(menuKey);
		} else {
			firstMenusIteam.DisplayName = i18n.t(firstMenusIteam.name);
		}
		firstMenusIteam.topName = i18n.t(firstMenusIteam.topName);
		
		if (firstMenusIteam.children == undefined || firstMenusIteam.children.length == 0) {
			if (firstMenusIteam.ParentId == 1) {
				Myrouters3.push({
					path: '/StationOverview', //运营总览
					title: '场站总览',
					name: '场站总览',
					topName: firstMenusIteam.topName,
					ParentId: firstMenusIteam.ParentId,
					component: (resolve) => require(['./components/BigScreen/BigScreen.vue'],
						resolve),
				})
				if (firstMenusIteam.name == "stationsOverview") {
					topMenus.push({
						path: '/StationOverview', //运营总览
						topName: firstMenusIteam.topName,
						name: firstMenusIteam.name,
						ParentId: firstMenusIteam.ParentId,
					})
				}
			} else {
				let comPath = componentGroup.filter(function(value, index, array) {
					return value.name == firstMenusIteam.name
				})[0];
				if (comPath == undefined) {
					comPath = componentGroup.filter(function(value, index, array) {
						return value.name == 'inDevelopment'
					})[0];
				}
				Myrouters3.push({
					meta: {
						menuId: firstMenusIteam.Id,
						widgets: firstMenusIteam.MenuWidgets
					},
					path: firstMenusIteam.path, //运营总览
					title: firstMenusIteam.DisplayName,
					name: firstMenusIteam.name + 's',
					topName: firstMenusIteam.topName,
					ParentId: firstMenusIteam.ParentId,
					icon: firstMenusIteam.Icon || comPath.icon,
					component: (resolve) => require(['./components/Escort'], resolve),
					redirect: firstMenusIteam.path + firstMenusIteam.path + "s",
					children: [{
						meta: {
							menuId: firstMenusIteam.Id,
							widgets: firstMenusIteam.MenuWidgets
						},
						path: firstMenusIteam.path.slice(1) + "s",
						title: firstMenusIteam.DisplayName,
						name: firstMenusIteam.name,
						icon: firstMenusIteam.Icon || comPath.icon,
						ParentId: firstMenusIteam.ParentId,
						component: comPath.component,// () => import(`${comPath.component}`)
						//component: (resolve) => require(['./components/tracking/system_function_device'], resolve),
					}]
				});
				if (!topMenus.some(function(obj) {
						return obj.ParentId == firstMenusIteam.ParentId
					})) {
					topMenus.push({
						path: firstMenusIteam.path, //运营总览
						topName: firstMenusIteam.topName,
						name: firstMenusIteam.name,
						ParentId: firstMenusIteam.ParentId,
						icon: firstMenusIteam.Icon || comPath.icon,
					})
				}
			}
		} else {
			let a = [];
			firstMenusIteam.children.forEach(function(secondMenusIteam, index, array) {
				// 优先使用菜单专用翻译键（如 SplitRuleMenu），否则使用默认键
				const menuKey = secondMenusIteam.name + 'Menu';
				if (i18n.te(menuKey)) {
					secondMenusIteam.DisplayName = i18n.t(menuKey);
				} else {
					secondMenusIteam.DisplayName = i18n.t(secondMenusIteam.name);
				}
				//secondMenusIteam.topName = i18n.t(secondMenusIteam.topName);
				console.log(secondMenusIteam)
				let comPath = componentGroup.filter(function(value, index, array) {
					return value.name == secondMenusIteam.name
				})[0];
				if (comPath == undefined) {
					comPath = componentGroup.filter(function(value, index, array) {
						return value.name == 'inDevelopment'
					})[0];
				}
				a.push({
					meta: {
						menuId: secondMenusIteam.Id,
						widgets: secondMenusIteam.MenuWidgets
					},
					path: secondMenusIteam.path,
					title: secondMenusIteam.DisplayName,
					name: secondMenusIteam.name,
					icon: secondMenusIteam.Icon || comPath.icon,
					ParentId: secondMenusIteam.ParentId,
					component: comPath.component, // () => import(`${comPath.component}`)
				})
			})
			Myrouters3.push({
				meta: {
					menuId: firstMenusIteam.Id,
					widgets: firstMenusIteam.MenuWidgets
				},
				path: firstMenusIteam.path, //运营总览
				title: firstMenusIteam.DisplayName,
				name: firstMenusIteam.name,
				topName: firstMenusIteam.topName,
				ParentId: firstMenusIteam.ParentId,
				icon: firstMenusIteam.Icon,
				component: (resolve) => require(['./components/Escort'], resolve),
				redirect: firstMenusIteam.redirect,
				children: a
			})
			if (!topMenus.some(function(obj) {
					return obj.ParentId == firstMenusIteam.ParentId
				})) {
				topMenus.push({
					path: firstMenusIteam.path, //运营总览
					topName: firstMenusIteam.topName,
					name: firstMenusIteam.name,
					ParentId: firstMenusIteam.ParentId,
				})
			}
		}
		//status = false;
		// localStorage.setItem("hasTopMenu", true);
	})

	topMenus.forEach(item=>{
		item.topName= i18n.t('Top.'+item.name);
	})

	console.log("topMenu", topMenus)
	localStorage.setItem("topMenus", JSON.stringify(topMenus));
	localStorage.setItem("menuFlag", 'unload');

	let routerList = [...Myrouters, ...Myrouters3]
	const newRouter = new VueRouter(RouterConfig);
	router.matcher = newRouter.matcher // the relevant part
	// forEach(routerList, (value, key, dict) => router.addRoute(value));
	router.addRoutes(routerList) //动态添加路由
	store.commit("upsilderMethod", Myrouters3)
	return routerList;
}

export default {
	router,
	Myrouters3,
	userRoute
}
